<template>
  <el-select v-model="selectValue" multiple filterable placeholder="请选择" @change="change">
    <el-option label="请选择" value=""></el-option>
    <el-option v-for="item in options" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: 'FormDictItemMultipleSelect',
    data() {
      return {
        options: [],
        selectValue: this.value
      }
    },
    props: {
      dictid: {
        type: Number
      },
      value: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    methods: {
      change: function(selVal) {
        this.$emit('input', selVal)
      }
    },
    watch: {
      value (newVal) {
        this.selectValue = newVal
      }
    },
    mounted: function() {
      // this.rolelevel = sessionStorage.getItem('rolelevel')
      // this.userid = sessionStorage.getItem('userid')
      var that = this
      var args = {
        token: sessionStorage.getItem('token'),
        dictid: this.dictid,
        currentPage: 1,
        pageSize: 99999
        // rolelevel: this.rolelevel,
        // userid: this.userid
      }
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/dictitem/list', args, function(data) {
        that.options = data.Data
      }, null, null, null)
    }
  }
</script>

<style scoped="scoped">
  .el-select {
    width: 100%;
  }
</style>
